function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
  id: "icon-close",
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.85 16l9.375-11.175c0.157-0.186 0.025-0.468-0.218-0.468h-2.85c-0.168 0-0.329 0.075-0.439 0.204l-7.732 9.218-7.732-9.218c-0.107-0.129-0.268-0.204-0.439-0.204h-2.85c-0.243 0-0.375 0.282-0.218 0.468l9.375 11.175-9.375 11.175c-0.042 0.049-0.068 0.114-0.068 0.184 0 0.157 0.127 0.284 0.284 0.284 0.001 0 0.001 0 0.002 0h2.85c0.168 0 0.329-0.075 0.439-0.204l7.732-9.218 7.732 9.218c0.107 0.129 0.268 0.204 0.439 0.204h2.85c0.243 0 0.375-0.282 0.218-0.468l-9.375-11.175z"
})));
function SvgSymbolDefs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolDefs);
export default __webpack_public_path__ + "static/media/symbol-defs.c60ba64d9c13f974b803c5fbcb8bd3b1.svg";
export { ForwardRef as ReactComponent };